"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Constants_1 = require("../Constants");
const coord_helper_service_1 = require("../../service/coord-helper.service");
const plugins_1 = require("./plugins");
const Cesium = window.Cesium;
class FlyAroundHandler extends plugins_1.FdmPlugin {
    constructor() {
        super(...arguments);
        this.debug = Constants_1.Constants.debug_off;
        this.controls = {
            show: { value: false, type: 'check' },
            distance: { value: 300, type: 'slider', min: 10, max: 800, step: 0.1 },
            pitch: { value: -0.74, type: 'slider', min: -1.5, max: 0.3, step: 0.02 },
            smoothness: { value: 10, type: 'slider', min: 1, max: 50, step: 1 },
            direction: { value: 1, type: 'slider', min: -1, max: 1, step: 1 },
            heading: { value: 0, type: 'slider', min: 0, max: 359, step: 0.1, noshow: true },
            showCenter: { value: false, type: 'check', group: 'GROUP_OFFSET' },
            centerSize: { value: 10, type: 'slider', min: 1, max: 100, step: 0.1, group: 'GROUP_OFFSET' },
            height: { value: 0, type: 'slider', min: -200, max: 200, step: 0.2, adjust: 'center', group: 'GROUP_OFFSET' },
            long: { value: 0, type: 'slider', min: -100, max: 100, step: 0.1, adjust: 'center', group: 'GROUP_OFFSET' },
            lat: { value: 0, type: 'slider', min: -100, max: 100, step: 0.1, adjust: 'center', group: 'GROUP_OFFSET' },
            size: { value: 1, type: 'slider', min: 0.5, max: 10, step: 0.1, adjust: 'size', group: 'GROUP_OFFSET' },
        };
        this.show = false;
        // movable parts
        this.center = null;
        this.adjustedCenter = null;
        this.adjustedHeight = 0;
        this.heading = 0;
        this.rotation = -1; // counter-clockwise
        // pitch:number = -0.74;
        // distance:number = 300;
        // smoothness:number = 1500;
        // Cesium event listener
        this.listener = null;
    }
    init() {
        // remember to stop the flying when the plugin is removed
        this.finalisers.push(() => this.stop());
        // let's use a sphere to mark the center position
        this.entity('sphere', this.services.mapService.viewer.entities.add({
            position: new Cesium.CallbackProperty(() => {
                return this.adjustedCenter;
            }, false),
            show: false,
            ellipsoid: {
                radii: new Cesium.CallbackProperty(() => {
                    return new Cesium.Cartesian3(this.controls.centerSize.value, this.controls.centerSize.value, this.controls.centerSize.value);
                }, false),
                material: Cesium.Color.YELLOW.withAlpha(0.2),
                outline: true,
                outlineColor: Cesium.Color.YELLOW.withAlpha(0.7),
                slicePartitions: 15,
                stackPartitions: 20,
            },
        }));
    }
    // manual injection of an entity to fly around
    injectEntity(e = null) {
        if (this.debug) {
            console.log('%c flyaround.plugin %c here()', this.debugPrimary, this.debugSecondary, e);
        }
        this.object = e;
    }
    getHeight(incoming = null) {
        let me = incoming;
        if (!me) {
            me = this.center;
        }
        let radians = Cesium.Cartographic.fromCartesian(me);
        let coord = new coord_helper_service_1.CoordGeodetic(radians, true);
        return coord.height;
    }
    getCenterCoord() {
        let radians = Cesium.Cartographic.fromCartesian(this.center);
        return new coord_helper_service_1.CoordGeodetic(radians, true);
    }
    updateCenter() {
        let coord = this.getCenterCoord();
        coord.height = coord.height + this.controls.height.value;
        coord.long = coord.long + (this.controls.long.value / 100000);
        coord.lat = coord.lat + (this.controls.lat.value / 100000);
        this.adjustedCenter = this.services.coordHelper.toCartesian(coord);
    }
    /*
    updateLong () {
        let coord = this.getCenterCoord();
        coord.long = coord.long + ( this.controls.long.value / 100000 );
        this.adjustedCenter = this.coordHelper.toCartesian ( coord );
    }
    updateLat () {
        let coord = this.getCenterCoord();
        coord.lat = coord.lat + ( this.controls.lat.value / 100000 );
        this.adjustedCenter = this.coordHelper.toCartesian ( coord );
    }
    */
    updateSphere() {
        let e = this.entity('sphere');
        if (e) {
            e.show = this.controls.showCenter.value;
            // console.log('b', this.controls.showCenter.value, this.adjustedCenter);
        }
    }
    updateSize() {
        this.controls.distance.max = 800 * this.controls.size.value;
        this.controls.long.min = -100 * this.controls.size.value;
        this.controls.long.max = 100 * this.controls.size.value;
        this.controls.lat.min = -100 * this.controls.size.value;
        this.controls.lat.max = 100 * this.controls.size.value;
        this.controls.height.min = -20 * this.controls.size.value;
        this.controls.height.max = 20 * this.controls.size.value;
    }
    refresh(newvalue = null, section = null) {
        // check in with mama
        super.refresh(newvalue, section);
        if (section && section['adjust']) {
            if (section['adjust'] == 'center') {
                this.updateCenter();
            }
            else if (section['adjust'] == 'size') {
                this.updateSize();
            }
        }
        this.updateSphere();
        if (this.show !== this.controls.show.value) {
            this.show = this.controls.show.value;
            this.showHide();
        }
    }
    // positions[] must be an x,y,z Cartesian array
    start(positions = [], distance = 300, pitch = -0.74, smoothness = 10) {
        if (positions['x']) {
            this.center = positions;
            if (this.debug) {
                console.log('%c flyaround.plugin %c start() INCOMING single', this.debugPrimary, this.debugSecondary, this.center);
            }
        }
        if (positions && positions['length']) {
            this.center = Cesium.BoundingSphere.fromPoints(positions).center;
            if (this.debug) {
                console.log('%c flyaround.plugin %c start() INCOMING multiple', this.debugPrimary, this.debugSecondary, this.center);
            }
        }
        // adjusted center is an adjustment we can make manually from the original center
        this.adjustedCenter = this.center;
        // also apply any offsets if set up
        this.updateCenter();
        // also any size offsets
        this.updateSize();
        if (this.debug) {
            console.log('%c flyaround.plugin %c start()', this.debugPrimary, this.debugSecondary, positions, this.center);
        }
        this.listener = this.services.mapService.viewer.clock.onTick.addEventListener(() => {
            let smoothness = (10000 / this.controls.smoothness.value) + (4000 / this.controls.smoothness.value);
            this.controls.heading.value += this.controls.direction.value * (Math.PI / smoothness);
            this.services.mapService.viewer.camera.lookAt(this.adjustedCenter, new Cesium.HeadingPitchRange(this.controls.heading.value, this.controls.pitch.value, this.controls.distance.value));
            // if ( this.inj1 ) { this.inj1.refreshInfoBoxes(); }
        });
    }
    stop() {
        if (this.debug) {
            console.log('%c flyaround.plugin %c stop()', this.debugPrimary, this.debugSecondary, this.listener);
        }
        this.services.mapService.viewer.camera.lookAtTransform(Cesium.Matrix4.IDENTITY);
        if (this.listener) {
            this.listener();
            this.services.mapService.viewer.flyTo(this.object);
        }
    }
    // overriding, using it as a start/stop mechanism
    showHide(state = this.show) {
        // new state
        this.show = state;
        // to avoid some 'this' spaghetti
        let me = this;
        // start
        if (this.show) {
            // whatever entity we're flying around is injected into the extra property
            if (this.object) {
                let positions = null;
                // TODO : this needs to go into some Cesium helper somewhere, it's nuts they don't have the same property name/structure for positions!
                if (this.object.polyline) {
                    // console.log ( 'polyline');
                    positions = this.object.polyline.positions._value;
                }
                else if (this.object.wall) {
                    // console.log ( 'wall');
                    positions = this.object.wall.positions._value;
                }
                else if (this.object.polygon) {
                    // console.log ( 'polygon');
                    positions = this.object.polygon.hierarchy.positions._value;
                }
                else if (this.object.positions) {
                    // console.log ( 'positions');
                    positions = this.object.positions._value;
                }
                else if (this.object.boundingSphere) {
                    // console.log ( 'boundingSphere');
                    positions = this.object.boundingSphere.center;
                }
                else if (this.boundingSphere) {
                    // console.log ( 'injected boundingSphere');
                    positions = this.boundingSphere.center;
                }
                else if (this.object.imageryProvider) {
                    // console.log ( 'imageryProvider' );
                    // avoid 'this' spahgetti in promises
                    this.object.getViewableRectangle().then(function (rectangle) {
                        let rect = Cesium.Rectangle.center(rectangle);
                        let co = new coord_helper_service_1.CoordGeodetic(rect, true);
                        // force at least some height in there for your viewing pleasure
                        co.height = 100;
                        me.controls.distance.max = 5000;
                        me.controls.distance.value = 2000;
                        me.services.coordHelper.updateCartesian(co);
                        // console.log ('!!!!', co);
                        if (co) {
                            me.start(co);
                        }
                    });
                }
                else if (this.item) {
                    // console.log ('!!!! from Item', this.item );
                    if (this.item.llng && this.item.llat) {
                        me.controls.distance.max = 5000;
                        me.controls.distance.value = 2000;
                        if (this.item.ulng && this.item.ulat) {
                            // we've got a rectangle of sorts
                            let a = new coord_helper_service_1.CoordGeodetic({ long: this.item.ulng, lat: this.item.ulat, height: 1000 });
                            this.services.coordHelper.updateCartesian(a);
                            let b = new coord_helper_service_1.CoordGeodetic({ long: this.item.ulng, lat: this.item.ulat, height: 1000 });
                            this.services.coordHelper.updateCartesian(b);
                            positions = [a, b];
                            // console.log ('!!!! from Item bounding', positions );
                        }
                        else {
                            // nope, only center coordinates
                            let center = new coord_helper_service_1.CoordGeodetic({ long: this.item.ulng, lat: this.item.ulat, height: 1000 });
                            this.services.coordHelper.updateCartesian(center);
                            positions = center;
                            // console.log ('!!!! from Item center', positions );
                        }
                    }
                }
                else {
                    console.log('unknown entity; dont know how to create a center flying point', this.object, this.item);
                }
                if (this.debug) {
                    console.log('%c flyaround.plugin %c showHide() trying to start', this.debugPrimary, this.debugSecondary, this.show, this.object, positions, this.boundingSphere);
                }
                // if ( this.debug ) { console.log ( '%c flyaround.plugin %c showHide() trying to start', this.debugPrimary, this.debugSecondary, this.object['imageryProvider']  ); }
                if (positions) {
                    this.start(positions);
                }
            }
            // stop
        }
        else {
            if (this.debug) {
                console.log('%c flyaround.plugin %c showHide() stop', this.debugPrimary, this.debugSecondary, this.show);
            }
            this.stop();
        }
    }
}
// Notes on translations
// There's a new meta.property called 'translator' which is the prefix of where in the language file this plugin lives. 
// All translations of controls use their key, so for example 'heading' becomes PLUGINS.[this_plugin].HEADING in the language file
// If there are groups that needs translation, use PLUGINS.[this_plugin].GROUP_[name_of_group]
FlyAroundHandler.meta = {
    label: 'PLUGINS.FLY_AROUND.LABEL',
    name: 'flyaround-handler',
    translator: 'PLUGINS.FLY_AROUND',
    tooltip: 'PLUGINS.FLY_AROUND.TOOLTIP',
    activeShortcut: true,
    icon: 'helicopter',
    category: plugins_1.FdmPlugin.category.generic,
    cardinality: plugins_1.FdmPlugin.cardinality.one,
    types: [plugins_1.FdmPlugin.types.transformController],
    ds_types: [plugins_1.FdmPlugin.ds_types.all],
    features: [plugins_1.FdmPlugin.features.startstop],
};
exports.FlyAroundHandler = FlyAroundHandler;
